<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link :key="collapse?'collapse':'expand'" class="sidebar-logo-link" to="">
        <img src="@/assets/images/logoIco.png" @click="logout" class="sidebar-logo" v-if="!collapse">
        <img src="@/assets/images/logoIcoSmall.png" @click="logout" class="sidebar-logo" v-else>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    async logout() {
      // await this.$store.dispatch('user/logout')
      // window.localStorage.removeItem("menus");
      // window.localStorage.removeItem("token");
      // window.localStorage.removeItem("UserName");
      // window.localStorage.removeItem("permissions");
      // window.localStorage.removeItem("UserId");
      // this.$router.push('/login')
      this.$router.push({ path: '/welcome'})
    }
  }
}
</script>

<style lang="scss" scoped>
$bg:#0063be;
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: $bg;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      vertical-align: middle;
    }
    
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
